export default __webpack_public_path__ + "static/media/enghien22.31ac0896.jpg";